<template>
  <!-- 添加SEO组件 -->
  <SeoMetaInfo
    :title="seoTitle"
    :description="seoDescription"
    :keywords="seoKeywords"
  />
  <div class="app-container">
    <a-config-provider :locale="zhCN">
      <router-view />
    </a-config-provider>
    <LoginRegModal />
  </div>
</template>

<script setup>
import zhCN from "ant-design-vue/es/locale/zh_CN";
import LoginRegModal from "@components/LoginRegModal.vue";
import SeoMetaInfo from "@components/SeoMetaInfo.vue";
</script>

<style>
@font-face {
  font-family: "PingFangSC-medium";
  src: url("./assets/font/PingFangSC-Medium.ttf") format("truetype");
  font-display: swap;
}
/* 全局样式 */
body,
html {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
}
body {
  overflow-y: scroll;
}
.app-container {
  min-height: 100vh;
  font-family: "PingFangSC-medium";
  background-color: #fff;
}
</style>